/**
 * Step 3 — date range. Quick single-month preset (RTL month nav — right caret
 * goes back a month, like the finance list) plus manual start/end DatePickers.
 */

import { CaretRight, CaretLeft, CalendarBlank } from "@phosphor-icons/react";
import DatePicker from "../../../../ui/DatePicker";

const monthLabel = (year, month) =>
  new Date(year, month - 1, 1).toLocaleDateString("he-IL", {
    month: "long",
    year: "numeric",
  });

function DateRangeStep({ wiz }) {
  const {
    startDate,
    endDate,
    setStartDateManual,
    setEndDateManual,
    presetMonth,
    applyMonthPreset,
    rangeInvalid,
  } = wiz;

  const now = new Date();
  const base = presetMonth || { year: now.getFullYear(), month: now.getMonth() + 1 };

  const goMonth = (delta) => {
    const d = new Date(base.year, base.month - 1 + delta, 1);
    applyMonthPreset(d.getFullYear(), d.getMonth() + 1);
  };

  return (
    <div className="prw-step-panel">
      <p className="prw-step-hint">בחרו חודש מהיר או טווח תאריכים מותאם</p>

      <div className="prw-month-preset">
        <span className="prw-month-preset-label">
          <CalendarBlank size={14} />
          בחירת חודש
        </span>
        <div className="prw-month-nav">
          <button
            type="button"
            className="prw-month-btn"
            onClick={() => goMonth(-1)}
            aria-label="חודש קודם"
          >
            <CaretRight size={14} weight="bold" />
          </button>
          <button
            type="button"
            className={`prw-month-label-btn ${presetMonth ? "active" : ""}`}
            onClick={() => applyMonthPreset(base.year, base.month)}
            aria-label="בחירת חודש זה"
          >
            {monthLabel(base.year, base.month)}
          </button>
          <button
            type="button"
            className="prw-month-btn"
            onClick={() => goMonth(1)}
            aria-label="חודש הבא"
          >
            <CaretLeft size={14} weight="bold" />
          </button>
        </div>
      </div>

      <div className="prw-date-row">
        <div className="prw-form-group">
          <label>מתאריך</label>
          <DatePicker
            name="startDate"
            value={startDate}
            onChange={(e) => setStartDateManual(e.target.value)}
            error={rangeInvalid}
          />
        </div>
        <div className="prw-form-group">
          <label>עד תאריך</label>
          <DatePicker
            name="endDate"
            value={endDate}
            onChange={(e) => setEndDateManual(e.target.value)}
            error={rangeInvalid}
          />
        </div>
      </div>

      {rangeInvalid && (
        <div className="prw-field-error">תאריך ההתחלה מאוחר מתאריך הסיום</div>
      )}
    </div>
  );
}

export default DateRangeStep;
